export default __webpack_public_path__ + "static/media/custom_triangle.77899b82.jpg";